module.exports = __webpack_public_path__ + "static/media/Header-image.a867ea7b.jpg";